module.exports = __webpack_public_path__ + "static/beauty-c8bc154c46ca3e18a93274f6a2c5949a.svg";